/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateReferralRequest,
} from '../models';

export interface ReferralApiControllerCreateRequest {
    createReferralRequest: CreateReferralRequest;
}

/**
 * 
 */
export class ReferralApi extends runtime.BaseAPI {

    /**
     */
    async referralApiControllerCreateRaw(requestParameters: ReferralApiControllerCreateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createReferralRequest === null || requestParameters.createReferralRequest === undefined) {
            throw new runtime.RequiredError('createReferralRequest','Required parameter requestParameters.createReferralRequest was null or undefined when calling referralApiControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/referral`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createReferralRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async referralApiControllerCreate(requestParameters: ReferralApiControllerCreateRequest): Promise<void> {
        await this.referralApiControllerCreateRaw(requestParameters);
    }

}
